import { invertStrObj } from '@Utils/invertObj';
import { RequestTypeCodes } from '@Enum/index';

import FeatureRoutePath from '../ESSFeatureRoutePath.enum';

export const RequestTypePerPath: { [key: string]: string } = {
  [RequestTypeCodes.LEAVE_REQUEST]:
    FeatureRoutePath.MANAGE_REQUEST_LEAVE_REQUEST,
  [RequestTypeCodes.PASSPORT_REQUEST]:
    FeatureRoutePath.MANAGE_REQUEST_PASSPORT_REQUEST,
  [RequestTypeCodes.IT_REQUISITION]:
    FeatureRoutePath.MANAGE_REQUEST_IT_REQUISITION,
  [RequestTypeCodes.SALARY_CERTIFICATE]:
    FeatureRoutePath.MANAGE_REQUEST_SALARY_CERTIFICATE,
  [RequestTypeCodes.OVERSEAS_MISSION]:
    FeatureRoutePath.MANAGE_REQUEST_OVERSEAS_MISSION,
  [RequestTypeCodes.RESUMPTION_REQUEST]:
    FeatureRoutePath.MANAGE_REQUEST_RESUMPTION_REQUESTS,
  [RequestTypeCodes.ATTENDANCE_REQUEST]:
    FeatureRoutePath.MANAGE_REQUEST_ATTENDANCE_REQUEST,
  [RequestTypeCodes.RESIGNATION_REQUEST]:
    FeatureRoutePath.MANAGE_REQUEST_RESIGNATION_REQUESTS,
};

export const RequestPathPerType = invertStrObj(RequestTypePerPath);
